document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    var swiperReviews = new Swiper(".swiperEvents", {
        slidesPerView: 1,
        loop: true,
        autoHeight: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".swiper-button-next-events",
            prevEl: ".swiper-button-prev-events",
        },
    });

    let swiperGallery = document.querySelectorAll('.gallery');
    if(swiperGallery){

        let swiperGallery1 = new Swiper('.swiperGallery', {
            loop: true,
            effect: 'fade',
            allowTouchMove: false,
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: ".swiper-gallery-next",
                prevEl: ".swiper-gallery-prev",
            },
        });       
        let swiperGallery2 = new Swiper('.swiperGallery2', {
            loop: true,
            effect: 'fade',
            initialSlide: 2,
            allowTouchMove: false,
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: ".swiper-gallery-next",
                prevEl: ".swiper-gallery-prev",
            },
        });  
        let swiperGallery3 = new Swiper('.swiperGallery3', {
            loop: true,
            effect: 'fade',
            initialSlide: 3,
            allowTouchMove: false,
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: ".swiper-gallery-next",
                prevEl: ".swiper-gallery-prev",
            },
        });  
        let swiperGallery4 = new Swiper('.swiperGallery4', {
            loop: true,
            effect: 'fade',
            initialSlide:4,
            allowTouchMove: false,
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: ".swiper-gallery-next",
                prevEl: ".swiper-gallery-prev",
            },
        });    
    };
    
    var swiperSlider = new Swiper(".swiperSlider", {
        slidesPerView: 1.1,
        spaceBetween: 20,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next-slider",
            prevEl: ".swiper-button-prev-slider",
        },
        breakpoints: {
            760: {
                slidesPerView: 1.1,
                spaceBetween: 20,
            },
            1025: {
                slidesPerView: 1.3,
                spaceBetween: 60,
            }
        }

    });

    if(document.querySelector('.swiperSpaces')){
        let swiperSpaces = new Swiper(".swiperSpaces", {
            loop: true,
            speed: 700,
            centeredSlides: true,
            effect: 'fade',
            allowTouchMove: false,
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: ".swiper-button-next-spaces",
                prevEl: ".swiper-button-prev-spaces",
            },
            on: {
                init: function () {
                    let srcActive = document.querySelector('.swiper-slide-prev .spaces-slider__image img').getAttribute('src');
                    let altActive = document.querySelector('.swiper-slide-prev .spaces-slider__image img').getAttribute('alt');
                    document.querySelector('.spaces-slider__left img').setAttribute('src', srcActive);
                    document.querySelector('.spaces-slider__left img').setAttribute('alt', altActive);
                }
            }
    
        });
    
        document.querySelectorAll('.swiper-button-prev-spaces, .swiper-button-next-spaces').forEach((arrow)=>{
            arrow.addEventListener('click', ()=>{
                let src = document.querySelector('.swiper-slide-next .spaces-slider__image img').getAttribute('src');
                document.querySelector('.spaces-slider__left').classList.remove('show');
                setTimeout(() => {
                    document.querySelector('.spaces-slider__left').classList.add('show');
                    document.querySelector('.spaces-slider__left img').setAttribute('src', src);
                }, 1);
            });
        });
    }


    var swiperAmenties = new Swiper(".swiperAmenities", {
        slidesPerView: 2,
        spaceBetween: 40,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next-amenities",
            prevEl: ".swiper-button-prev-amenities",
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween:65,
            }
        }
    });

    var swiperSliderSecondary = new Swiper(".swiperSliderSecondary", {
        slidesPerView: 1,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        uniqueNavElements: false,
        pagination: {
            el: '.second-slider-pagination',
            clickable: true
        }
    });

    var swiperReviews = new Swiper(".swiperReviews", {
        slidesPerView: 1,
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
    });

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    const locationMap = document.querySelector("[data-swipermap]");
    if(locationMap){
        const map = new Swiper(locationMap, {
			speed: 700,
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			
            navigation: {
                nextEl: ".swiper-button-next-location",
                prevEl: ".swiper-button-prev-location",
            },
            breakpoints: {
                1280: {
                    allowTouchMove: false,
                }
            }
		})
    }

    const swiper_card = document.querySelector(".swiper-card");
    if(swiper_card){
        const swiper_card_swiper = new Swiper(swiper_card, {
			speed: 700,
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			loop: true,
            navigation: {
                nextEl: ".swiper-button-next-card",
                prevEl: ".swiper-button-prev-card",
            },
            autoHeight: true,
            breakpoints: {
                1280: {
                    allowTouchMove: false,
                }
            }
		})
    }

    document.querySelectorAll('[data-swiper-goto]').forEach((item) => {
        const target = item.dataset.swiperGoto ? parseInt(item.dataset.swiperGoto) : 0
        const slider = item.dataset.swipertarget ? document.querySelector(item.dataset.swipertarget) : item.closest('.swiper-slider')
        item.addEventListener('click', (e) => {
            slider.swiper.slideTo(target)
            document.querySelectorAll(`[data-swiper-goto]`).forEach((itm) => itm.classList.remove('active'))
            item.classList.add('active')
        })
    })

});